import { apiRequest } from '@/utils/api-request';
import { UserPat } from './create-user-pat';

export const getUserPats = async (): Promise<UserPat[]> => {
  const response = await apiRequest<UserPat[]>({
    url: '/api-tokens',
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to get personal access tokens');
  }

  return response.data ?? [];
};
